var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"thanks"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.thanks1)}}),_c('p',{domProps:{"innerHTML":_vm._s(_vm.thanks2)}})])}
var staticRenderFns = []

export { render, staticRenderFns }